<div class="accordion info" id="Filters">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFilters">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
        data-bs-target="#collapseFilters" aria-expanded="false" aria-controls="collapseOne">
        <img src="../../../assets/images/icons/icon-filter-green.svg"> <span>Filtros</span>
      </button>
    </h2>
    <div id="collapseFilters" class="accordion-collapse collapse" aria-labelledby="headingFilters"
      data-bs-parent="#Filters">
      <div class="accordion-body">
        <div class="cont__form">
          <div class="row">
            <div class="form-group col-xl-3 col-md-6 mb-2">
              <label class="form-label">Periodo</label>
              <select2 [(ngModel)]="filter.IdAnimation" [value]="filter.IdAnimation" id="animations" [data]="animations"
                class="select2"></select2>
            </div>
            <div class="form-group col-xl-3 col-md-6 mb-2" *ngIf="distributors.length>0">
              <label class="form-label">Concesionario</label>
              <select2 [(ngModel)]="filter.IdDistributor" [value]="filter.IdDistributor" id="distributor"
                [data]="distributors" class="select2">
              </select2>
            </div>
            <div class="form-group col-xl-1 col-md-2 mb-2" *ngIf="anios.length>0">
              <label class="form-label">Año</label>
              <select2 [(ngModel)]="filter.Year" id="year" [value]="filter.Year" [data]="anios" class="select2">
              </select2>
            </div>
            <div class="form-group col-xl-2 col-md-4 mb-2" *ngIf="meses.length>0">
              <label class="form-label">Mes</label>
              <select2 [(ngModel)]="filter.Month" id="month" [value]="filter.Month" [data]="meses" class="select2">
              </select2>
            </div>
            <div class="form-group col-xl-2 col-md-4 mb-2" *ngIf="types.length>0">
              <label class="form-label">Tipo de acción</label>
              <select2 [(ngModel)]="filter.IdType" [value]="filter.IdType" (close)="GetSelectedType($event)" id="types"
                [data]="types" class="select2">
              </select2>
            </div>
            <div class="form-group col-xl-2 col-md-4 mb-2" *ngIf="medias.length>0">
              <label class="form-label">Medio</label>
              <select2 [(ngModel)]="filter.IdMedia" [value]="filter.IdMedia" id="medias" [data]="medias"
                class="select2"></select2>
            </div>
            <div class="form-group col-xl-2 col-md-4 mb-2" *ngIf="status.length>0">
              <label class="form-label">Estado</label>
              <select2 [(ngModel)]="filter.IdStatus" [value]="filter.IdStatus" id="status" [data]="status"
                class="select2"></select2>
            </div>
          </div>
          <div class="form-buttons">
            <button (click)="filterData()" type="button" class="btn-primary">Filtrar</button>
            <button (click)="resetData()" type="button" class="btn-dark-line ">Limpiar filtros</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="budgetModel.length>0">
  <div class="cont__total_cost">
    <h3>Gastos totales: {{animationTitle}}</h3>
    <div class="cont__highlights">
      <div class="highlight totalConsumed" *ngIf="totalConsumed">
        <span class="type">Consumido</span>
        <span class="total">{{totalConsumed}} €</span>
      </div>
      <div class="highlight totalAsigned" *ngIf="totalAsigned">
        <span class="type">Asignado:</span>
        <span class="total">{{totalAsigned}} €</span>
      </div>
    </div>
  </div>
  <div class="graph__module">
    <div class="title_graphs"><img src="../../../assets/images/icons/icon-graphs.svg"> <span>Desglose por
        acciones</span>
    </div>
    <div class="cont__budget_graph">
      <app-budget-graph *ngIf="budgetModel[0].TotalBudget > 0" [title]="budgetModel[0].Type"
        [totalBudget]="budgetModel[0].TotalBudgetString" [modelProvisional]="budgetModel[0].ProvGraph"
        [modelConfirmed]="budgetModel[0].ConfGraph" [graphIndex]="0">
      </app-budget-graph>
      <app-budget-graph *ngIf="budgetModel[1].TotalBudget > 0" [title]="budgetModel[1].Type"
        [totalBudget]="budgetModel[1].TotalBudgetString" [modelProvisional]="budgetModel[1].ProvGraph"
        [modelConfirmed]="budgetModel[1].ConfGraph" [graphIndex]="1">
      </app-budget-graph>
      <app-budget-graph *ngIf="budgetModel[2].TotalBudget > 0" [title]="budgetModel[2].Type"
        [totalBudget]="budgetModel[2].TotalBudgetString" [modelProvisional]="budgetModel[2].ProvGraph"
        [modelConfirmed]="budgetModel[2].ConfGraph" [graphIndex]="2">
      </app-budget-graph>
    </div>
  </div>
</div>
<div class="cont__actions_history cont__form">
  <h3>Historial de acciones de Marketing: {{animationTitle}}</h3>
  <div class="actions_history">
    <a *ngIf="fromLeapmotorzone" (click)="DownloadExcelAction()" class="btn-green-line">
      Resumen de pagos <img src="../../../assets/images/icons/icon-file-excel.svg" alt="Excel"></a>
    <button [routerLink]="['/mkt-coop/edit']" class="btn-primary" *ngIf="!fromLeapmotorzone && showCreateButton"><i
        class="fa-solid fa-plus"></i> Nueva propuesta</button>
  </div>
</div>

<!-- <div *ngIf="fromLeapmotorzone" class="row">
  <div *ngIf="animations.length>0" class="col-2 mb-2">
    <div class="form-group form-float">
      <label class="form-label">Animaciones</label>
      <select2 [(ngModel)]="animationSelected" [value]="animationSelected" id="animations" [data]="animations"
        class="select2"></select2>
    </div>
  </div>
  <a (click)="DownloadExcelAction()" class="btn btn-outline-secondary"><i class="fa fa-download" aria-hidden="true"></i>
    Descargar liquidaciones</a>
</div> -->


<table id="tblAction" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
  class="table data-tables dataTable condensed-table no-footer mkt-plan w-100">
  <thead>
    <tr>
      <th class="w-4">Código</th>
      <th>Concesionario</th>
      <th class="text-center w-8">Periodo</th>
      <th class="text-center w-9">Fecha<br />propuesta</th>
      <th class="text-center w-5">Fecha<br />aprobación</th>
      <th class="text-center w-12">Estado</th>
      <th class="w-10">Acción</th>
      <th class="w-8">Medio</th>
      <th class="text-end w-8">Importe previsto total</th>
      <th class="text-end w-6">Subvención Leapmotor</th>
      <th class="text-end w-4">Comentarios</th>
      <th class="text-center w-8">Factura</th>
      <th class="text-center w-2">Ver</th>
    </tr>
  </thead>
</table>